var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item",
      class: { item2: _vm.type != 1, item11: _vm.type == 11 },
      on: {
        click: function ($event) {
          return _vm.lookDetails(_vm.item.courseLinks)
        },
      },
    },
    [
      _vm.type == 11
        ? _c("div", { staticClass: "img" }, [
            _c("img", {
              attrs: {
                src: _vm.item.courseCover
                  ? _vm.item.courseCover
                  : _vm.$store.getters.noImg,
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type !== 9
        ? _c("div", { staticClass: "mainText" }, [
            _c("div", { staticClass: "tit" }, [
              _vm._v(_vm._s(_vm.item.courseName)),
            ]),
            _vm._v(" "),
            _vm.type == 11
              ? _c("div", [
                  _c("div", { staticClass: "sourse" }, [
                    _c("img", {
                      attrs: { src: require("../assets/img/people.png") },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text_w" }, [
                      _vm._v(
                        _vm._s(
                          _vm.item.presidingTeacher
                            ? _vm.item.presidingTeacher
                            : ""
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sourse" }, [
                    _c("img", {
                      attrs: { src: require("../assets/img/image/chanye.png") },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text_w" }, [
                      _vm._v(
                        _vm._s(
                          _vm.item.majorTypeName
                            ? _vm.item.majorTypeName
                            : "---"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sourse" }, [
                    _c("img", {
                      attrs: { src: require("../assets/img/image/hangye.png") },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text_w" }, [
                      _vm._v(
                        _vm._s(
                          _vm.item.industryDetailName
                            ? _vm.item.industryDetailName
                            : "---"
                        )
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }